// Ek dosya kuralları — backend'deki tickets.attachment.* ayarlarıyla aynı değerler.
// Buradaki kontroller kullanıcıya anında geri bildirim içindir; son söz backend'indir:
// sunucu ayrıca dosyanın gerçek içeriğini (magic byte) doğrular ve görseli yeniden kodlar.

export const MAX_ATTACHMENTS = 5;
export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

/**
 * Kabul edilen türler (backend TicketAttachmentType ile aynı küme).
 * Yalnız görsel: her ek sunucuda çözülüp yeniden yazılabilsin diye PDF ve WebP kaldırıldı.
 */
export const ACCEPTED_EXTENSIONS = [".png", ".jpg", ".jpeg"];
export const ACCEPTED_MIME_TYPES = ["image/png", "image/jpeg", "image/jpg"];
export const ACCEPT_ATTRIBUTE = [...ACCEPTED_EXTENSIONS, ...ACCEPTED_MIME_TYPES].join(",");

export const isImageAttachment = (contentType) =>
    typeof contentType === "string" && contentType.toLowerCase().startsWith("image/");

/** Okunabilir dosya boyutu (1023 B, 12.4 KB, 3.1 MB). */
export const formatFileSize = (bytes) => {
    if (bytes === null || bytes === undefined) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * Dosya seçiciden gelen dosyayı doğrular.
 * @returns {string|null} hata mesajı, uygunsa null
 */
export const validateAttachment = (file) => {
    const name = file?.name || "dosya";
    const extension = name.includes(".") ? name.slice(name.lastIndexOf(".")).toLowerCase() : "";

    if (!ACCEPTED_EXTENSIONS.includes(extension)) {
        return `${name}: yalnız ${ACCEPTED_EXTENSIONS.join(", ")} dosyaları eklenebilir.`;
    }
    if (file.size > MAX_FILE_SIZE) {
        return `${name}: dosya boyutu ${MAX_FILE_SIZE_MB} MB sınırını aşıyor.`;
    }
    return null;
};

/**
 * Panodan yapıştırılan görseli doğrular. Yapıştırılan içeriğin dosya adı (dolayısıyla
 * uzantısı) güvenilir değildir — tarayıcı çoğunlukla "image.png" der; bu yüzden
 * kontrol tarayıcının bildirdiği tür üzerinden yapılır.
 */
export const validatePastedImage = (file) => {
    if (!ACCEPTED_MIME_TYPES.includes((file?.type || "").toLowerCase())) {
        return "Yalnız png ve jpg görseller yapıştırılabilir.";
    }
    if (file.size > MAX_FILE_SIZE) {
        return `Yapıştırılan görsel ${MAX_FILE_SIZE_MB} MB sınırını aşıyor.`;
    }
    return null;
};

/** Panodan gelen görseli base64 (data URI) olarak okur — sunucuya bu biçimde gider. */
export const readAsDataUri = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
